export default {
  setProfileOptionsLoadingState(state, loading) {
    state.profileOptionsLoading = loading;
  },
  setProfileOptionsState(state, options) {
    state.profileOptions = options;
  },
  setBasicProfileDataState(state, data) {
    state.basicProfileData = data;
  },
  mutateBasicProfileDataErrorsState(state, data) {
    state.basicProfileDataErrors[data.key] = data.message;
  },
  mutateBasicProfileDataState(state, data) {
    state.basicProfileData = {...state.basicProfileData, ...data};
  },
  setJobTitlesOptionsState(state, data) {
    state.jobTitlesOptions = data;
  },
  setJobTitlesOptionsLoadingState(state, loading) {
    state.jobTitlesOptionsLoading = loading;
  }
};
